(function () {
    var SVG_PLAY = '<svg style="color:inherit" width=".9em" height=".7em" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.28674 0.854166L4.63361 5.98333C4.58349 6.05343 4.51736 6.11057 4.44073 6.14998C4.3641 6.18939 4.27916 6.20996 4.19299 6.20996C4.10681 6.20996 4.02188 6.18939 3.94524 6.14998C3.86861 6.11057 3.80248 6.05343 3.75236 5.98333L0.0992364 0.855208C0.0420467 0.774241 0.00817214 0.679133 0.00130247 0.580243C-0.00556721 0.481354 0.0148317 0.382475 0.0602768 0.294378C0.105722 0.206281 0.174471 0.132344 0.259034 0.0806212C0.343598 0.028898 0.440734 0.00137149 0.539862 0.00104109L7.84611 0C7.94524 0.000330395 8.04237 0.0278559 8.12694 0.0795792C8.2115 0.131302 8.28025 0.205239 8.3257 0.293336C8.37114 0.381433 8.39154 0.480312 8.38467 0.579201C8.3778 0.678091 8.34393 0.773199 8.28674 0.854166Z" fill="currentColor"/></svg>';
    var SVG_LOADING = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="1em" height="1em" class="icon"><path d="M286.7 96.1C291.7 113 282.1 130.9 265.2 135.9C185.9 159.5 128.1 233 128.1 320C128.1 426 214.1 512 320.1 512C426.1 512 512.1 426 512.1 320C512.1 233.1 454.3 159.6 375 135.9C358.1 130.9 348.4 113 353.5 96.1C358.6 79.2 376.4 69.5 393.3 74.6C498.9 106.1 576 204 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 204 141.1 106.1 246.9 74.6C263.8 69.6 281.7 79.2 286.7 96.1z" fill="currentColor"/></svg>';

    function renderImage(item) {
        var el = document.createElement('img');
        el.src = item.thumbnail;
        el.alt = item.title;
        return el;
    }

    function renderVideo(item) {
        var div = document.createElement('div');
        div.className = 'video-card';
        div.innerHTML =
            '<div class="video-player">' +
                '<video src="' + esc(item.video_url) + '" poster="' + esc(item.thumbnail) + '" loop></video>' +
                '<button>' + SVG_PLAY + '</button>' +
            '</div>' +
            '<p>' + esc(item.title) + '</p>';
        return div;
    }

    function isPlaceholderTeam(name) {
        if (!name) return true;
        if (/^Team\s+[a-z0-9]{10,}$/i.test(name)) return true;
        if (name.indexOf('/') !== -1) return true;
        return false;
    }

    function renderHighlight(item) {
        var matchHtml = '';
        if (item.fixture) {
            var f = item.fixture;
            var homeFlagCode = f.home_flag || 'uz';
            var awayFlagCode = f.away_flag || 'pt';
            var homeName = isPlaceholderTeam(f.home_name) ? 'TBD' : f.home_name;
            var awayName = isPlaceholderTeam(f.away_name) ? 'TBD' : f.away_name;
            matchHtml =
                '<div class="highlight-card__match">' +
                    '<div class="highlight-card__team">' +
                        '<img src="https://flagcdn.com/w80/' + esc(homeFlagCode) + '.png" alt="' + esc(homeName) + ' flag"/>' +
                        '<p>' + esc(homeName) + '</p>' +
                    '</div>' +
                    '<div class="highlight-card__score">' +
                        '<span class="highlight-card__score-number">' + esc(f.goals_home) + '</span>' +
                        '<span>-</span>' +
                        '<span class="highlight-card__score-number highlight-card__score-number--reverse">' + esc(f.goals_away) + '</span>' +
                    '</div>' +
                    '<div class="highlight-card__team">' +
                        '<img src="https://flagcdn.com/w80/' + esc(awayFlagCode) + '.png" alt="' + esc(awayName) + ' flag"/>' +
                        '<p>' + esc(awayName) + '</p>' +
                    '</div>' +
                '</div>';
        }
        var div = document.createElement('div');
        div.className = 'highlight-card';
        div.innerHTML =
            '<div class="video-player">' +
                '<video src="' + esc(item.video_url) + '" poster="' + esc(item.thumbnail) + '" loop></video>' +
                '<button>' + SVG_PLAY + '</button>' +
            '</div>' +
            '<div class="highlight-card__headline">' +
                matchHtml +
                '<p>' + esc(item.title) + '</p>' +
            '</div>';
        return div;
    }

    function renderMoment(item) {
        var a = document.createElement('a');
        a.className = 'moment-card moment-card--narrow';
        a.setAttribute('data-video-src', item.video_url);
        a.setAttribute('href', '#moments_video');
        a.setAttribute('draggable', 'false');
        a.innerHTML =
            '<img src="' + esc(item.thumbnail) + '" alt="' + esc(item.title) + '" draggable="false"/>' +
            '<div class="indicator--loading hidden" role="status" aria-live="polite"><span>' + SVG_LOADING + '</span></div>' +
            '<video class="hidden" muted autoplay></video>' +
            '<div class="moment-card__content">' +
                '<div class="moment-card__content-badge">Khoảnh khắc</div>' +
                '<div class="moment-card__content-title"><p>' + esc(item.title) + '</p></div>' +
            '</div>';
        return a;
    }

    var ENDPOINT_MAP = {
        'images':                    { path: 'images',     render: renderImage },
        'videos':                    { path: 'videos',     render: renderVideo },
        'highlights':                { path: 'highlights', render: renderHighlight },
        'moments':                   { path: 'moments',    render: renderMoment },
        'load_more_media_images':    { path: 'images',     render: renderImage },
        'load_more_media_videos':    { path: 'videos',     render: renderVideo },
        'load_more_media_highlights':{ path: 'highlights', render: renderHighlight },
        'load_more_media_moments':   { path: 'moments',    render: renderMoment },
    };

    function esc(str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.load-more-btn').forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();

                var target   = button.dataset.target;
                var page     = parseInt(button.dataset.page, 10) || 1;
                var maxPages = parseInt(button.dataset.maxPages, 10) || 1;
                var catId    = button.dataset.catId || '';
                var limit    = button.dataset.limit || '';
                var type     = button.dataset.type || '';
                var key      = button.dataset.endpoint || button.dataset.action || 'images';
                var config   = ENDPOINT_MAP[key] || ENDPOINT_MAP['images'];

                var nextPage = page + 1;
                if (nextPage > maxPages) { button.style.display = 'none'; return; }

                button.disabled    = true;
                button.textContent = 'Đang tải...';

                var params = new URLSearchParams({ page: nextPage, limit: limit });
                if (catId) params.set('cat_id', catId);
                if (type)  params.set('type', type);

                fetch(mediaApiVars.rest_url + '/' + config.path + '?' + params.toString(), {
                    headers: { 'Accept': 'application/json' },
                })
                .then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json();
                })
                .then(function (data) {
                    if (!data || !data.success || !data.items || !data.items.length) {
                        button.style.display = 'none';
                        return;
                    }
                    var container = document.querySelector(target);
                    if (container) {
                        data.items.forEach(function (item) {
                            container.appendChild(config.render(item));
                        });
                    }
                    button.dataset.page = nextPage;
                    if (nextPage >= (data.max_pages || maxPages)) {
                        button.style.display = 'none';
                    } else {
                        button.disabled    = false;
                        button.textContent = 'Tải thêm';
                    }
                })
                .catch(function () {
                    button.disabled    = false;
                    button.textContent = 'Lỗi, thử lại';
                });
            });
        });
    });
}());
